import CardZakat from './CardZakat';

export default CardZakat;
